module.exports = __webpack_public_path__ + "static/media/canonica-san-pellegrino.d9ed27e4.svg";